import React, {useState} from 'react';
import {useLocation} from 'react-router-dom';
import network0x41 from '../networks/0x41.json';
import network0x61 from '../networks/0x61.json';
import network0x7A69 from '../networks/0x7A69.json';
import TelegramERC20Contract from '../contracts/TelegramERC20.json';
import {useAccount, useContractRead} from "wagmi";
import {getNetwork, switchNetwork, waitForTransaction, writeContract} from '@wagmi/core';

function getNetworkDefinition(networkIdentifier) {
    switch (networkIdentifier) {
        case '0x61':
            return network0x61;
        case '0x7A69':
            return network0x7A69;
        case '0x41':
        default:
            return network0x41;
    }
}

const DepositForm = () => {

    // Input field for the deposit amount
    const [amount, setAmount] = useState('1');
    const {isConnected, address} = useAccount();
    const {chain} = getNetwork();

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const contractAddress = searchParams.get('contract');
    const networkIdentifier = searchParams.get('network');
    const telegramAccountIdentifier = searchParams.get('account');

    const {data: billingTokenAddress} = useContractRead({
        address: contractAddress,
        abi: TelegramERC20Contract.abi,
        functionName: 'getBillingTokenAddress'
    });

    const {data: telegramTokenName} = useContractRead({
        address: contractAddress,
        abi: TelegramERC20Contract.abi,
        functionName: 'name'
    });

    const {data: price} = useContractRead({
        address: contractAddress,
        abi: TelegramERC20Contract.abi,
        functionName: 'getPrice'
    });

    // Which Ethereum address is registered to this Telegram account
    const {data: registeredEthereumAddress} = useContractRead({
        address: contractAddress,
        abi: TelegramERC20Contract.abi,
        functionName: 'telegramAccounts',
        args: [telegramAccountIdentifier]
    });

    const {data: billingTokenName} = useContractRead({
        address: billingTokenAddress,
        abi: TelegramERC20Contract.abi,
        functionName: 'name'
    });

    if (!isConnected) {

        // return <div className="spinner"></div>;

        return <></>;
    }

    if (!contractAddress || !networkIdentifier || !telegramAccountIdentifier) {
        return <div>
            <b>Telegram ERC-20 Bridge</b> needs you to specify:
            <ul>
                <li>bridge contract address;</li>
                <li>network identifier;</li>
                <li>Telegram account identifier.</li>
            </ul>
        </div>
    }

    // Check, whether the current network matches the network identifier
    if (Number(chain.id) !== Number(parseInt(networkIdentifier, 16))) {
        function onSwitchNetwork() {
            switchNetwork({
                chainId: Number(networkIdentifier)
            }).then(() => {
                console.log("Will reload");
                window.location.reload();
            });
        }

        return (
            <div>
                <h1>Wrong Network</h1>
                <p>Please switch to network {networkIdentifier} in MetaMask to proceed.</p>
                <button onClick={onSwitchNetwork}>Switch Network</button>
            </div>
        );
    }


    // Deposit function
    const depositTokens = async () => {

        async function processDeposit() {

            // Approve spending the billing token
            const approveBillingTokenResult = await writeContract({
                address: billingTokenAddress,
                abi: TelegramERC20Contract.abi,
                functionName: 'approve',
                args: [contractAddress, Number(amount)],
            });

            await waitForTransaction({
                hash: approveBillingTokenResult.hash,
                confirmations: 1,
            });

            // Deposit the billing token
            const depositResult = await writeContract({
                address: contractAddress,
                abi: TelegramERC20Contract.abi,
                functionName: 'deposit',
                args: [Number(amount)],
            });

            await waitForTransaction({
                hash: depositResult.hash,
                confirmations: 1,
            });

            // Clear the input field
            setAmount('1');
            alert('Tokens deposited successfully');
        }

        if (address !== registeredEthereumAddress) {

            const registerTelegramAccountResult = await writeContract({
                address: contractAddress,
                abi: TelegramERC20Contract.abi,
                functionName: 'registerTelegramAccount',
                args: [Number(telegramAccountIdentifier)],
            });

            await waitForTransaction({
                hash: registerTelegramAccountResult.hash,
                confirmations: 1,
            });

            await processDeposit();
        } else {
            await processDeposit();
        }
    };

    const network = getNetworkDefinition(networkIdentifier);
    const billingTokenUri = `${network.blockExplorerUrls[0]}${billingTokenAddress}`;
    const telegramTokenUri = `${network.blockExplorerUrls[0]}${contractAddress}`;

    return (
        <div>
            <h1>Deposit <a href={billingTokenUri} target="__billing_token">{billingTokenName}</a> into <a
                href={telegramTokenUri} target="__telegram_token">{telegramTokenName}</a></h1>
            <input
                type="number"
                placeholder="Enter the amount to deposit"
                value={amount}
                onChange={(e) => {
                    const value = e.target.value;
                    if (value >= 1) {
                        setAmount(value);
                    }
                }}
            />
            <button onClick={depositTokens}>Deposit</button>
            <br/>
            <b>You will get</b>: {amount * Number(price)} {telegramTokenName}.
        </div>
    );
};

export default DepositForm;
